import { AdParams, AdSlots } from './ads.types';
import { ErrorReporter } from '../errorReporter.type';
import { oldInitAds } from './ads';

export const registerInitAdsForGooglePersonalizationData = (adSlots: AdSlots, params: AdParams, adsCategory: string, headerBidderPublisherID: string, errorProvider: ErrorReporter, iniAdsCallback: typeof oldInitAds) => {
  if (!window.__cmp) {
    errorProvider.reportException({
      name: 'cmp',
      message: 'window.__cmp is undefined. CMP script probably was not executed on time, therefore shouldNotPersonalizeAds = true',
    });
    iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, true);
  } else {
    // @ts-ignore TS2722
    window.__cmp('getConsentData', null, (consentData: { gdprApplies: boolean }) => {
      if (!consentData.gdprApplies) {
        iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, false);
      } else {
        // @ts-ignore TS2722
        window.__cmp('getGooglePersonalization', (googlePersonalizationConsent: { googlePersonalizationData: {consentValue: 0 | 1} }, isSuccessToGetGooglePersonalization: boolean) => {
          if (!isSuccessToGetGooglePersonalization || !googlePersonalizationConsent || !googlePersonalizationConsent.googlePersonalizationData) {
            iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, true);
          } else if (googlePersonalizationConsent.googlePersonalizationData.consentValue === 0) {
            iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, true);
          } else if (googlePersonalizationConsent.googlePersonalizationData.consentValue === 1) {
            iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, false);
          } else {
            iniAdsCallback(adSlots, params, adsCategory, headerBidderPublisherID, errorProvider, true);
          }
        });
      }
    });
  }
};
